import { render, staticRenderFns } from "./RateForClassModal.vue?vue&type=template&id=0f2d864e&scoped=true"
import script from "./RateForClassModal.vue?vue&type=script&lang=js"
export * from "./RateForClassModal.vue?vue&type=script&lang=js"
import style0 from "./RateForClassModal.vue?vue&type=style&index=0&id=0f2d864e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d864e",
  null
  
)

export default component.exports